import React from 'react';
import icons from '../../assets/icons/icons';

const Icon = ({
    src,
    alt,
    className = '',
    style = {},
    onClick,
    whiteicon,
}) => {
    const iconPath = icons[src];

    if (!iconPath) return null;

    return (
        <img
            src={iconPath}
            alt={alt || src}
            className={[className, whiteicon].filter(Boolean).join(' ')}
            style={style}
            onClick={onClick}
        />
    );
};

export default Icon;
